// Tyler.API.MetaData.GridEditType
export enum GridEditType {
    ReadOnlyGrid = 1,
    MetadataPanel = 2,
    Cell = 3,
    CardList = 4,
    Groupable = 5
}
